import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { ProductDetailsDialogComponent } from '../products/product-details-dialog.component';
import { ProductLabelDialogService } from './product-label-dialog.service';

@Component({
  selector: 'app-product-preview-details-dialog',
  standalone: true,
  imports: [CommonModule, RouterModule, MatDialogModule],
  templateUrl: './product-preview-details-dialog.component.html',
  styleUrls: ['../products/products.component.scss']
})
export class ProductPreviewDetailsDialogComponent extends ProductDetailsDialogComponent {
  private readonly labels = inject(ProductLabelDialogService);

  showPackageLabel(): void {
    const uuid = this.detail?.record.package_uuid || this.data.row.package_uuid;
    if (!uuid) {
      return;
    }
    this.labels.open(uuid, this.data.theme);
  }
}
